import { isAuthenticated } from '../utils/api';
import SignIn from '../components/Account/SignIn/SignIn';
import {   useNavigate } from "react-router-dom";
function ProtectedRoute(props) {
  const navigate = useNavigate();
  return (
    isAuthenticated()?
    <> { props.component } </> : <><SignIn/></>  
  )
}
export default ProtectedRoute